import {
  getGasFee,
  getL2TransferGasFee,
  getPrivateTokenTransactionHistory,
  getTransactionHistory,
} from './wallet-service.resource';

type Request = {
  data?: unknown;
  method?: string;
  url: string;
};

type Fetcher = (request: Request) => Promise<unknown>;

export type WalletServiceGasEstimateResponse = {
  btc?: number | string;
  eth?: number | string;
  usd?: number | string;
};

export type WalletServiceBitcoinBalanceResponse = {
  balance?: number;
  rawData?: {
    final_balance?: number;
  };
};

export type WalletServiceTransaction = Record<string, unknown>;

export type WalletServiceTransactionHistoryResponse = {
  wallet?: Array<{
    totalPages?: number;
    totalRecords?: number;
    transactions?: WalletServiceTransaction[];
  }>;
};

export type ExplorerTransaction = {
  confirmations?: number | string;
  contractAddress?: string;
  from?: string;
  gasPrice?: number | string;
  gasUsed?: number | string;
  hash?: string;
  input?: string;
  isError?: string;
  status?: string;
  timeStamp?: number | string;
  to?: string;
  tokenDecimal?: number | string;
  txreceipt_status?: string;
  value?: number | string;
};

export type ExplorerTransactionHistoryResponse = {
  result?: ExplorerTransaction[];
};

export type WalletServiceTransactionHistoryParams = {
  core: boolean;
  page: number;
  pageSize: number;
  sortBy: string;
  sortDir: string;
  symbol: string;
};

export type WalletServiceClient = {
  estimateGas(params: {
    amount: string | number;
    core: boolean;
    symbol: string;
    to: string;
  }): Promise<WalletServiceGasEstimateResponse>;
  estimateLayer2Gas(params: {
    amount: number;
    core: boolean;
    to: string;
  }): Promise<number | string>;
  getBitcoinBalance(params: {
    address: string;
    network: string;
  }): Promise<WalletServiceBitcoinBalanceResponse>;
  getPrivateTokenTransactionHistory(params: {
    page: number;
    pageSize: number;
    sortBy: string;
    sortDir: string;
    url: string;
  }): Promise<ExplorerTransactionHistoryResponse>;
  getTransactionHistory(
    params: WalletServiceTransactionHistoryParams
  ): Promise<WalletServiceTransactionHistoryResponse>;
};

export const createWalletServiceClient = (fetcher: Fetcher): WalletServiceClient => ({
  estimateGas: ({ amount, core, symbol, to }) =>
    fetcher(
      getGasFee({ amount, core, symbol, to })
    ) as Promise<WalletServiceGasEstimateResponse>,
  estimateLayer2Gas: ({ amount, core, to }) =>
    fetcher(getL2TransferGasFee({ amount, core, to })) as Promise<number | string>,
  getBitcoinBalance: ({ address, network }) => {
    const params = new URLSearchParams({ address, network });

    return fetcher({
      url: `/api/coins/btcBalance?${params}`,
    }) as Promise<WalletServiceBitcoinBalanceResponse>;
  },
  getPrivateTokenTransactionHistory: (params) =>
    fetcher(
      getPrivateTokenTransactionHistory(params)
    ) as Promise<ExplorerTransactionHistoryResponse>,
  getTransactionHistory: (params) =>
    fetcher(
      getTransactionHistory(params)
    ) as Promise<WalletServiceTransactionHistoryResponse>,
});
